import * as types from "./mutation_types";

export default {
	[types.UPLOAD_DATA](state: any, data: any) {
		state.uploadData = data.data;
	},
};
